import { createSlice } from '@reduxjs/toolkit';

interface NetworkState {
  isOnline: boolean;
}
interface ValidationStatus {
    totalFields: number;
    completedFields: number;
    validationResults?: Array<{
      palletId: number;
      isValid: boolean;
      errors?: Record<string, any>;
      stagesWithMissingValues?: string[];
    }>;
  }
const initialState: NetworkState = {
  isOnline: navigator.onLine,
  isValid: false,
  validationStatus:null as ValidationStatus | null

};

const networkSlice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    setNetworkStatus: (state, action) => {
      state.isOnline = action.payload;
    },
    setIsValid: (state, action) => {
      state.isValid = action.payload;
    },
    setValidationStatus: (state, action) => {
      state.validationStatus = action.payload;
    }
  }
});

export const { setNetworkStatus,setIsValid,setValidationStatus } = networkSlice.actions;
export default networkSlice.reducer;


// const [validationStatus, setValidationStatus] = useState<{
//     totalFields: number;
//     completedFields: number;
//     validationResults?: Array<{
//       palletId: number;
//       isValid: boolean;
//       errors?: Record<string, any>;
//       stagesWithMissingValues?: string[];
//     }>;
//   }>();